import { SensorModelConfiguration } from '../types';

/**
 * Configuration du modèle MILESIGHT TS201
 * Capteur de température uniquement
 */
export const MILESIGHT_TS201: SensorModelConfiguration = {
  brand: 'MILESIGHT',
  model: 'TS201',
  metrics: {
    temperature: {
      type: 'number',
      unit: '°C',
      icon: 'TemperatureIcon',
      color: 'error.main',
      labelRef: 'temperature'
    }
  }
};
